import { Carousel } from 'bootstrap';
document.addEventListener('DOMContentLoaded', function () {
    const carousels = document.querySelectorAll('.carousel');
    const carouselInstances = Array.from(carousels).map(carousel => new Carousel(carousel));
    const carouselStates = new Map();
    const pauseAllCarousels = () => {
        carouselInstances.forEach((instance, index) => {
            const carousel = carousels[index];
            if (!carouselStates.get(carousel)) {
                instance.pause();
                carouselStates.set(carousel, true);
            }
        });
    };
    const resumeAllCarousels = () => {
        carouselInstances.forEach((instance, index) => {
            const carousel = carousels[index];
            if (carouselStates.get(carousel)) {
                instance.cycle();
                carouselStates.set(carousel, false);
            }
        });
    };
    carousels.forEach((carousel, index) => {
        carousel.addEventListener('mouseenter', () => {
            pauseAllCarousels();
            const carouselElement = carousels[index];
            if (carouselStates.get(carouselElement) === false) {
                carouselInstances[index].cycle();
                carouselStates.set(carouselElement, false);
            }
        });
        carousel.addEventListener('mouseleave', () => {
            resumeAllCarousels();
        });
    });
});
